<div class="error-page1  bg-light">
    <!-- Page -->
<div class="page">

<router-outlet></router-outlet>
            

</div>
<!-- End Page -->
</div>